export const rules = {
  visitor: {
    rules: ["homePage:visit"]
  },
  superadmin: {
    rules: [
      "surgeons:list",
      "surgeons:create",
      "activeCases:list",
      "activeCases:edit",
      "completedCases:list",
      "abortCases:list",
      "processStatus:list",
      "surgeonsapprovalPage:visit",
      "homePage:visit",
      "dashboardPage:visit"
    ]
  },
  writeadmin: {
    rules: [
      "surgeons:list",
      "surgeons:create",
      "activeCases:list",
      "completedCases:list",
      "abortedCases:list",
      "processStatus:list",
      "surgeonsapprovalPage:visit",
      "homePage:visit",
      "dashboardPage:visit"
    ]
  },
  readadmin: {
    rules: [
      "surgeons:list",
      "activeCases:list",
      "completedCases:list",
      "abortedCases:list",
      "processStatus:list",
      "surgeonsapprovalPage:visit",
      "dashboardPage:visit",
      "homePage:visit"
    ]
  },
  distributor: {
    rules: [
      "surgeons:list",
      "activeCases:list",
      "completedCases:list",
      "abortedCases:list",
      "processStatus:list",
      "surgeonsapprovalPage:visit",
      "dashboardPage:visit",
      "homePage:visit"
    ]
  },
  hospital: {
    rules: [
      "surgeons:list",
      "activeCases:list",
      "completedCases:list",
      "abortedCases:list",
      "processStatus:list",
      "surgeonsapprovalPage:visit",
      "dashboardPage:visit",
      "homePage:visit"
    ]
  },
  surgeon: {
    rules: [
      "surgeons:list",
      "activeCases:list",
      "activeCases:order",
      "surgeonsapproval:approve",
      "surgeonsapprovalPage:visit",
      "dashboardPage:visit",
      "HomePage:visit",
    ]
  }
}
